import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@webapp/ui/components/toast/toast.service';
import { ICreateAdminPayload } from '../../../interfaces/users.interface';
import { UsersStoreService } from '../../../store/users-store.service';
import { CreateAdminFormComponent } from '../../components/create-admin-form/create-admin-form.component';

@Component({
	selector: 'app-create-admin-page',
	standalone: true,
	imports: [CreateAdminFormComponent],
	templateUrl: './create-admin-page.component.html',
	styleUrl: './create-admin-page.component.scss',
})
export class CreateAdminPageComponent {
	private readonly usersStore = inject(UsersStoreService);
	private readonly router = inject(Router);
	private readonly toastService = inject(ToastService);

	readonly loading = signal(false);

	async onFormSubmit(payload: ICreateAdminPayload): Promise<void> {
		this.loading.set(true);

		try {
			await this.usersStore.createAdmin(payload);
			this.loading.set(false);
			this.toastService.showToast(
				'Usuario creado',
				'El usuario administrador se creó correctamente.',
				'success'
			);
			await this.router.navigate(['/usuarios']);
		} catch {
			this.loading.set(false);
			this.toastService.showToast(
				'Error',
				'No se pudo crear el usuario. Intente nuevamente.',
				'error'
			);
		}
	}
}
